import React, { useState } from "react";
import { translator } from "../../utils/i18n";
import { useDispatch, useSelector } from "react-redux";
import { DateTime } from "luxon";
import EventIcon from "@material-ui/icons/Event";
import DateRangeIcon from "@material-ui/icons/DateRange";
import QueryBuilderIcon from "@material-ui/icons/QueryBuilder";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import FooterPatientArea from "./FooterPatientArea";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import WaitingRoom from "./WaitingRoom";
import PropTypes from "prop-types";

import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import {
  deleteAppointment,
  // initValues,
  switchWidgetAppointment
} from "../../utils/fetcher";
import {
  IconButton,
  Button,
  Chip,
  Avatar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Tooltip
} from "@material-ui/core";

function HomePatientArea({ handleChange }) {
  const dispatch = useDispatch();
  const deleteAppointmentFunc = id => dispatch(deleteAppointment(id));

  const list = useSelector(state =>
    state.patientArea.myAppointments ? state.patientArea.myAppointments : []
  );
  const infosWaitingRoom = useSelector(state => state.waitingRoom) || {};

  const [deleteAppointmentId, setDeleteAppointmentId] = useState(undefined);

  const edit = token => {
    dispatch(switchWidgetAppointment(token));
  };

  const goToEdit = urlEdit => {
    const currentURL = window.location.href;
    const newParams = `token_rdv=${urlEdit}`;
    const separator = currentURL.includes("?") ? "&" : "?";
    const updatedURL = currentURL + separator + newParams;
    window.location.href = updatedURL;
  };

  const getRenderLastAppointment = () => {
    const lastAppointment = list[0];
    const dateAppointment = DateTime.fromFormat(
      `${lastAppointment.year}-${lastAppointment.month}-${
        lastAppointment.day
      }T${lastAppointment.Hour} Europe/Paris`,
      "yyyy-M-d'T'HH:mm z"
    );
    const duration = dateAppointment
      .diffNow(["months", "days", "hours", "minutes"])
      .toObject();

    return (
      <>
        <div className="next-appointment">
          {deleteAppointmentId !== undefined && (
            <Dialog
              open={open}
              onClose={() => setDeleteAppointmentId(undefined)}
              aria-labelledby="responsive-dialog-title"
            >
              <DialogContent>
                <DialogContentText>
                  {translator()._(
                    "W_SOUHAITEZ_VOUS_VRAIMENT_SUPPRIMER_RENDEZ_VOUS"
                  )}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  autoFocus
                  onClick={() => setDeleteAppointmentId(undefined)}
                  color="primary"
                >
                  {translator()._("W_ANNULER")}
                </Button>
                <Button
                  onClick={() => {
                    deleteAppointmentFunc(deleteAppointmentId);
                    setDeleteAppointmentId(undefined);
                  }}
                  color="primary"
                  autoFocus
                >
                  {translator()._("W_OUI")}
                </Button>
              </DialogActions>
            </Dialog>
          )}
          <Avatar
            className="logo-custom"
            variant="circular"
            sizes="60"
            src={
              lastAppointment.pictureDoctor ? lastAppointment.pictureDoctor : ""
            }
          >
            {!lastAppointment.pictureDoctor && (
              <>
                {lastAppointment.lastNameDoctor.charAt(0)}
                {lastAppointment.firstNameDoctor.charAt(0)}
              </>
            )}
          </Avatar>
          <div className="picto-next-appointment">
            {lastAppointment.token && (
              <Tooltip title={translator()._("W_MODIFIER")}>
                <IconButton
                  color="primary"
                  aria-label="edit"
                  onClick={() =>
                    lastAppointment.token
                      ? goToEdit(lastAppointment.token)
                      : edit(lastAppointment.token)
                  }
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>
            )}
            {lastAppointment.deletable && (
              <Tooltip title={translator()._("W_MODIFIER")}>
                <IconButton
                  color="primary"
                  aria-label="edit"
                  onClick={() =>
                    setDeleteAppointmentId(lastAppointment.appointmentId)
                  }
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            )}
          </div>
          <div className="text align-center">
            <div>
              <strong>
                {lastAppointment.civilityDoctor}{" "}
                {lastAppointment.firstNameDoctor}{" "}
                {lastAppointment.lastNameDoctor}
              </strong>
            </div>
            <span className="d-block text-gray size-m">
              {lastAppointment.motif}
            </span>
            <div>
              <div className="d-flex justify-content-between">
                <span className="date d-flex align-items-center text-bold-500 mr-10">
                  <PermIdentityIcon className="mr-6" />
                  {lastAppointment.firstName + " " + lastAppointment.lastName}
                </span>
                <span className="date d-flex align-items-center text-bold-500 mr-20">
                  <DateRangeIcon className="mr-6" />
                  {lastAppointment.date}
                </span>
                <span className="hour d-flex align-items-center text-bold-500">
                  <QueryBuilderIcon className="mr-6" />
                  {lastAppointment.Hour}
                </span>
              </div>
            </div>
            {translator()._("W_RESTE_PROCHAIN_RENDEZ_VOUS")} :&nbsp;
            <span className="text-orange text-bold-500">
              {duration.months > 0 && (
                <span>
                  <span className="text-capitalise">
                    {Math.floor(duration.months)}{" "}
                    {translator()._("W_STEP4_FORMULAIRE_MOIS")}&nbsp;
                  </span>
                  {duration.days ? "," : translator()._("W_ET")}&nbsp;
                </span>
              )}
              {duration.days > 0 && (
                <span>
                  <span className="text-capitalise">
                    {Math.floor(duration.days)} {translator()._("CP_JOURS")}
                    &nbsp;
                  </span>
                  {duration.hours ? "," : translator()._("W_ET")}&nbsp;
                </span>
              )}
              {duration.hours > 0 && (
                <span>
                  <span className="text-capitalise">
                    {Math.floor(duration.hours)} {translator()._("CP_HEURES")}
                    &nbsp;
                  </span>
                  {duration.minutes ? translator()._("W_ET") : ""}&nbsp;
                </span>
              )}
              {duration.minutes > 0 && (
                <span>
                  <span className="text-capitalise">
                    {Math.floor(duration.minutes)} {translator()._("W_MINUTES")}
                  </span>
                </span>
              )}
            </span>
            <div
              className={
                duration.days === 0 ? "wrap-buttons scan-actif" : "wrap-buttons"
              }
            >
              <Chip
                icon={<EventIcon />}
                label={translator()._("W_VOIR_RENDEZ_VOUS")}
                color="secondary"
                onClick={handleChange}
              />
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="home-page">
      <h1 className="title-page">{translator()._("CP_WELCOME_TITLE")}</h1>

      {infosWaitingRoom.gotoRoom ? (
        <WaitingRoom />
      ) : (
        <>
          {list.length > 0 && getRenderLastAppointment()}
          {list.length === 0 && (
            <div className="align-center">
              <div className="wrap-image">
                <img src="images/weekly-calendar.svg" alt="" width="200" />
                <div>
                  <strong className="d-block">
                    {translator()._("W_AUCUN_RENDEZ_VOUS_DISPONIBLE")}
                  </strong>
                  <span className="text-gray text-s d-block">
                    {translator()._("W_PRENDRE_NOUVEAU_RENDEZ_VOUS")}
                  </span>
                  <ArrowDownwardIcon color="primary" />
                </div>
              </div>
            </div>
          )}
        </>
      )}
      <FooterPatientArea />
    </div>
  );
}

export default HomePatientArea;

HomePatientArea.propTypes = {
  handleChange: PropTypes.func
};
